import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { AiOutlineSearch } from "react-icons/ai";
import { Card, Alert } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import success from "../../assets/img/success.png";
import FileBase64 from "../../components/Upload/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { makeStyles } from "@mui/styles";
import { adminGetCountryList } from '../../redux/actions/adminGetCountryList';
import { AdmingetAdminBankLists } from '../../redux/actions/adminGetBankNameListAction';
import { adminAddNewBankList } from '../../redux/actions/adminAddNewBankAction';
import { AdminGetBankList } from "../../redux/actions/adminGetBankAction";
import Util from "../../validation";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminBankMaster = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [addCountry, setaddCountry] = useState('');
    const [addBankName, setaddBankName] = useState('');

    const [setAddUpdateResp, setsetAddUpdateResp] = useState(false);
    const [selectedCountry, setselectedCountry] = useState('');

    const [getBankListStatus, setGetBankListStatus] = useState(false);
    const [getBankListArray, setGetBankListArray] = useState("");

    const [getBankNameListStatus, setGetBankNameListStatus] = useState(false);
    const [getBankNameListArray, setGetBankNameListArray] = useState([]);


    const [addOpen, setAddOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [editOpen, seteditOpen] = useState(false);
    const [editCountryId, seteditCountryId] = useState('');
    const [editCountryName, seteditCountryName] = useState('');
    const [editBankName, seteditBankName] = useState('');
    const [getBankName, setGetBankName] = useState([])

    const [bankSlip, setBankSlip] = useState("");

    const [nidFrontsName, setNidFrontsName] = useState("");
    const [nidFronts, setNidFronts] = useState("");


    const [UploadFileName, setUploadFileName] = useState("");
    const [uploadFile, setUploadFile] = useState("");

    const [countryList, setcountryList] = useState([])
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [respDescriptionAddUpdate, setrespDescriptionAddUpdate] = useState('');



    const classes = useStyles();

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);

    const addOrUpdateBankRes = useSelector(({ adminAddNewBanksLists }) => adminAddNewBanksLists);

    const AdminGetBankRes = useSelector(({ adminGetBanksLists }) => adminGetBanksLists);
    const getCountryListRes = useSelector(({ getCountryList }) => getCountryList);
    console.log("getCountryListResss", getCountryListRes)

    const getBankNameListRes = useSelector(({ adminGetBanksNameLists }) => adminGetBanksNameLists)

    // var authToken = regenerateTokenRes.data.AuthToken;
    const dispatch = useDispatch();

    // Ensure authToken is always based on the latest regenerateTokenRes
    const authToken = regenerateTokenRes.data?.AuthToken; // Use optional chaining for safety
    const partnerId = regenerateTokenRes.data?.partnerId; // Use optional chaining for safety

    const getCountryResp = () => {
        if (getCountryListRes.data.status === 'success') {
            setIsLoading(false);
            setcountryList(getCountryListRes.data.customerMasterDetailsRequestVOList);
        }
        if (getCountryListRes.data.status === 'failed') {
            if (
                getCountryListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getCountryListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, partnerId);
            }
            setIsLoading(false);
        }
    }
    // Effect to handle initial country list fetch and subsequent status changes
    useEffect(() => {
        // Only call if authToken is available (after initial render or regeneration)
        if (authToken) {
            getCountryListListReq();
        }
    }, [authToken]);
    useEffect(() => {
        if (getCountryListRes.data) { // Only run if data exists
            getCountryResp();
        }
    }, [getCountryListRes.data]);

    useEffect(() => {
        getCountryListListReq()
    }, [addOrUpdateBankRes.data.status]);

    const getCountryListListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: "",
                countryCode: "",
                countryIso: ""
            }
        }
        dispatch(adminGetCountryList(req, authToken));
    };

    const getBankNameListReq = () => {
        setGetBankNameListStatus(true)
        const Request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: selectedCountry
            }
        }
        dispatch(AdmingetAdminBankLists(Request, authToken));

    }

    const getBankNameListFunc = () => {
        if (getBankNameListStatus) {
            if (getBankNameListRes.data.status == "success") {
                setGetBankNameListArray(getBankNameListRes.data.customerMasterDetailsRequestVOList);
            }
            if (getBankNameListRes.data.status == "failed") {
                setGetBankNameListArray(getBankNameListRes.data);
                if (
                    getBankNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getBankNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, partnerId);
                }
            }
        }
    };

    useEffect(() => {
        if (selectedCountry) {
            getBankNameListReq()
        }
    }, [selectedCountry, addOrUpdateBankRes.data.status])


    useEffect(() => {
        if (getBankNameListRes.data) { // Ensure data exists before processing
            getBankNameListFunc();
        }
    }, [getBankNameListRes.data])


    useEffect(() => {
        setGetBankName('')
    }, [selectedCountry])



    const handleAttachmentsDoc = (e, uploadFile, nidFronts) => {
        if (uploadFile == "uploadFile") {
            setUploadFile(e.base64);
            setUploadFileName(e.name);

        }
        else if (uploadFile == "nidFronts") {
            setNidFronts(e.base64);
            setNidFrontsName(e.name);
        }

    };
    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editCountryId') {
            seteditCountryId(value);
        }
        if (name === 'editCountryName') {
            // seteditCountryName(value);
            Util.alphaNumeric(value) ? seteditCountryName(value) : seteditCountryName(editCountryName);

        }
        if (name === 'editBankName') {
            // seteditBankName(value)
            Util.alphaNumeric(value) ? seteditBankName(value) : seteditBankName(editBankName);
        }

    }
    const editModal = (id, name, code, banksImg) => {
        seteditCountryId(id);
        seteditCountryName(name);
        seteditBankName(code);
        setBankSlip(banksImg)
        // setNidFrontsName(bankImg)
        setNidFrontsName('')
        seteditOpen(true);
    }

    const closeEditModal = () => {
        seteditOpen(false);
    }

    const editSubmitReq = () => {
        setsetAddUpdateResp(true);
        const editReq = {
            actionCustomerMasterRequestVO: {
                // adminId: regenerateTokenRes.data.partnerId,
                adminId: val.adminIDS,
                id: editCountryId,
                country: editCountryName,
                bankName: editBankName,
                qrCode: nidFronts.split(",")[1] || bankSlip


            }
        }
        dispatch(adminAddNewBankList(editReq, authToken));
        seteditOpen(false);
    }



    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setrespDescriptionAddUpdate('');
    }

    const addOrUpdateNewBankRespFunc = () => {
        if (setAddUpdateResp) {
            if (addOrUpdateBankRes.data.status === 'sucess') {
                setrespDescriptionAddUpdate(addOrUpdateBankRes.data.description);
                setnotificationOpen(true);
                adminGetBankReq()

            }
            if (addOrUpdateBankRes.data.status === 'failed') {
                setrespDescriptionAddUpdate(addOrUpdateBankRes.data.description);
                setnotificationOpen(true);
                if (
                    addOrUpdateBankRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addOrUpdateBankRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        addOrUpdateNewBankRespFunc()
    }, [addOrUpdateBankRes.data.status]);




    const addUpdateBankSubmitFunc = () => {
        setsetAddUpdateResp(true);
        const addOrUpdateBankReq = {
            actionCustomerMasterRequestVO: {
                // adminId: regenerateTokenRes.data.partnerId,
                adminId: val.adminIDS,
                id: '',
                country: selectedCountry,
                bankName: addBankName,
                qrCode: uploadFile.split(",")[1]
            }
        }
        dispatch(adminAddNewBankList(addOrUpdateBankReq, authToken));
        setAddOpen(false)
    }


    const adminGetBankReq = () => {
        setIsLoading(true);
        setGetBankListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: selectedCountry,
                bankName: getBankName
            }
        }
        dispatch(AdminGetBankList(searchReq, authToken));

    }

    useEffect(() => {
        adminGetBankReq()
    }, [])

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            adminGetBankReq();
        }
    }, [regenerateTokenRes.data.status]);
    //}, [AdminGetBankRes.data.status]);

    const adminGetBankFunc = () => {
        if (getBankListStatus) {
            if (AdminGetBankRes.data.status == "success") {
                setGetBankListArray([].concat(AdminGetBankRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);

            }
            if (AdminGetBankRes.data.status == "failed") {
                setGetBankListArray(AdminGetBankRes.data);
                setIsLoading(false);
                if (
                    AdminGetBankRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    AdminGetBankRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }

            }
            if (AdminGetBankRes.data.status == "NOT FOUND") {
                setGetBankListArray(AdminGetBankRes.data)
                setIsLoading(false)
            }
        }
    }
    useEffect(() => {
        adminGetBankFunc();
    }, [AdminGetBankRes.data.status]);


    useEffect(() => {
        if (AdminGetBankRes.data.status === "success") {
            setPage(0);
        }
        if (AdminGetBankRes.data.status === 'failed') {
            if (
                AdminGetBankRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                AdminGetBankRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [AdminGetBankRes.data.status]);

    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addCountry') {
            setaddCountry(value);
        }
        if (name === 'addBankName') {
            // setaddBankName(value)
            Util.alphaNumeric(value) ? setaddBankName(value) : setaddBankName(addBankName);
        }

    }
    const addBankModalOpen = () => {
        setAddOpen(true);
        // setaddCountry('')
        setselectedCountry('')
        setaddBankName('')
        setUploadFileName('')
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChange = ({ target: { name, value } }) => {
        if (name === "countryList") {
            setselectedCountry(value === "Select Country" ? "" : value);
            // console.log('Selected Country: ', value);
        }
        if (name === "getBankName") {
            // setBankName(value)
            setGetBankName(value == "Select Bank" ? "" : value);

        }
    };
    const handleClose = () => {
        setAddOpen(false);


    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => addBankModalOpen()}
                            >
                                Add New Bank
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <NavLink to="/index/adminMappingBank">
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}

                                >
                                    Manage Bank
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>


                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Country"
                                variant='standard'
                                fullWidth={true}
                                name="countryList"
                                value={selectedCountry || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {countryList &&
                                    [].concat(countryList).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank"
                                fullWidth={true}
                                name="getBankName"
                                variant='standard'

                                value={getBankName || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Bank"
                                    selected="Select Bank"
                                >
                                    Select Bank
                                </MenuItem>
                                {/* {getCountryListRes &&
                                    [].concat(getCountryListRes).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))} */}
                                {getBankNameListRes.success &&
                                    [].concat(getBankNameListRes.data.customerMasterDetailsRequestVOList).map((x) => (
                                        <MenuItem value={x.bankName}>{x.bankName}</MenuItem>
                                    ))}

                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={4} lg={4}>

                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank"
                                fullWidth={true}
                                name="countryList"
                                // value={selectedCountry || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Bank
                                </MenuItem> */}
                        {/* {countryList &&
                                    [].concat(countryList).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))} */}
                        {/* </TextField>
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={adminGetBankReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getBankListArray.length == undefined ||
                    !getBankListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank ID{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country ISO
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Name
                                                </TableCell>




                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getBankListArray &&
                                                []
                                                    .concat(getBankListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.countryIso}
                                                            </TableCell>
                                                            <TableCell align="center">{row.bankName}</TableCell>

                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => editModal(row.id, row.countryName, row.bankName, row.bankImage)}
                                                                >
                                                                    <EditIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>




                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getBankListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}

            </Layout>

            <div>
                <Dialog open={editOpen} onClose={closeEditModal}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Edit Bank
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            disabled
                            variant='standard'
                            color="primary"
                            type="text"
                            label="Id"
                            fullWidth={true}
                            name="editCountryId"
                            value={editCountryId || ""}
                            onChange={editHandleChange}
                        ></TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant='standard'

                            type="text"
                            label="Country Name"
                            fullWidth={true}
                            name="editCountryName"
                            value={editCountryName || ""}
                            onChange={editHandleChange}
                        ></TextField>


                        <TextField
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Bank Name"
                            fullWidth={true}
                            variant='standard'

                            name="editBankName"
                            value={editBankName || ""}
                            onChange={editHandleChange}
                        ></TextField>

                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <Typography
                                variant="body1"
                                align="justify"
                                gutterBottom={true}
                                style={{ color: "#4f6c8d" }}
                            >
                                Upload
                            </Typography>
                            <FileBase64
                                multiple={false}
                                name={false}
                                id="documentGuard1"
                                accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
                                onDone={(e) => handleAttachmentsDoc(e, "nidFronts")}
                                showUploadList={false}
                                value={nidFrontsName}
                            />
                            {nidFrontsName ? nidFrontsName : ""}
                        </div>
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"

                            onClick={closeEditModal}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"

                            onClick={editSubmitReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Add Bank
                    </DialogTitle>
                    <DialogContent>
                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Country Name"
                            fullWidth={true}
                            name="addCountry"
                            value={addCountry || ""}
                            onChange={onInputChange}
                        ></TextField> */}
                        <TextField
                            select
                            size="small"
                            color="primary"
                            type="text"
                            label="Country"
                            fullWidth={true}
                            variant='standard'
                            name="countryList"
                            value={selectedCountry || ''}
                            onChange={handleChange}
                        >
                            <MenuItem
                                value="Select Country"
                                selected="Select Country"
                            >
                                Select Country
                            </MenuItem>
                            {countryList &&
                                [].concat(countryList).map((x) => (
                                    <MenuItem key={x.id} value={x.countryName}>
                                        {x.countryName}
                                    </MenuItem>
                                ))}
                        </TextField>


                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Bank Name"
                            fullWidth={true}
                            variant='standard'

                            name="addBankName"
                            value={addBankName || ""}
                            onChange={onInputChange}
                        ></TextField>

                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <Typography
                                variant="body1"
                                align="justify"
                                gutterBottom={true}
                                style={{ color: "#4f6c8d" }}
                            >
                                Upload
                            </Typography>
                            <FileBase64
                                multiple={false}
                                name={false}
                                id="documentGuard1"
                                accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
                                onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
                                showUploadList={false}
                                value={UploadFileName}
                            />
                            {UploadFileName ? UploadFileName : ""}
                        </div>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={addUpdateBankSubmitFunc}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>


            {addOrUpdateBankRes.data.status == "sucess" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addOrUpdateBankRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminBankMaster


